import React, { useEffect } from 'react'
import { Link,useLocation} from 'react-router-dom'
import Slider from '../../components/Slider/Slider'
import './Home.css'
import topImage from '../../assets/images/topImage.jpg'
import about1 from '../../assets/images/about1.png'
import healthcare from '../../assets/images/Healthcare.png'
import PatientResources from '../../assets/images/Patient Resources.png'
import Investor from '../../assets/images/Investor Relations.png'
import Sustainability from '../../assets/images/Sustainability & Responsibility.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const Home = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);

  return (
    <div>
      <Slider />
      <div className="container py-lg-5">
        <div className="row">
          <div className="col-lg-6 mb-3 d-flex align-items-center">
            <img className='img-fluid' data-aos="zoom-in" src={topImage} alt="" />
          </div>
          <div className="col-lg-6">
            <div className='d-flex flex-column justify-content-center h-100 '>
              <h1 className='main-heading' data-aos="zoom-in">Welcome to Oreus Lifesciences!</h1>
              <p className='home-content' data-aos="zoom-in">
                We are committed to improving global health through innovation and excellence in pharmaceutical care. With a focus on quality and patient safety, Oreus Lifesciences offers a wide range of prescription drugs, OTC products, and cutting-edge medical solutions. Explore our comprehensive portfolio and discover how we are shaping the future of healthcare.
              </p>
              <p className='quick-highlight' data-aos="zoom-in">
                <i className="bi bi-arrow-right-short"></i>Pioneering pharmaceutical innovations.</p>
              <p className='quick-highlight' data-aos="zoom-in"><i className="bi bi-arrow-right-short"></i> Global presence with trusted partners.</p>
              <p className='quick-highlight' data-aos="zoom-in"><i className="bi bi-arrow-right-short"></i>Patient-first approach in drug development and distribution.</p>
            </div>

          </div>
        </div>
      </div>

      {/* Start About Us Section  */}
      <div className="container py-lg-5">
        <div className="row">
          <div className="col-12">
          <h1 className="main-heading" data-aos="zoom-in">About Us</h1>
          </div>
        </div>
        <div className="row py-lg-5 py-3">
          <div className="col-lg-6 col-md-6" >
            <img className='img-fluid'data-aos="zoom-in" src={about1} alt="" />
          </div>
          <div className="col-lg-6 col-md-6" data-aos="zoom-in">
            <h5>Mission Statement</h5>
            <p>
              At Oreus Lifesciences, our mission is to enhance the quality of life through affordable, innovative, and effective pharmaceutical solutions. We aim to bridge the gap between science and healthcare to ensure better patient outcomes.
            </p>
            <h5>Vision</h5>
            <p>To be a global leader in pharmaceutical innovation, shaping the future of healthcare through research, compassion, and excellence.</p>
            <h5>History & Milestones</h5>
            <p> Founded in 2023, Oreus Lifesciences has grown into a trusted name in the pharmaceutical industry, recognised for our cutting-edge research and commitment to patient care. Over the years, we have expanded into various therapeutic areas and increased our global reach through strategic partnerships.
            </p>
          </div>
        </div>
        {/* <div className="row">
          <h1 className='main-heading py-lg-3' data-aos="zoom-in">Leadership Team</h1>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="leadership-team" data-aos="zoom-in">
              <img className='img-fluid' src={about2} alt="" />
              <div className='leader'>
                <span>Nimisha Gupta</span><br />
                <span>Director</span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="leadership-team" data-aos="zoom-in">
              <img className='img-fluid' src={about3} alt="" />
              <div className='leader'>
                <span>Atul Mishra</span><br />
                <span>Director</span>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="leadership-team" data-aos="zoom-in">
              <img className='img-fluid' src={about4} alt="" />
              <div className='leader'>
                <span>Ashish Kumar</span><br />
                <span>Director</span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      {/* End About Us Section  */}

      {/* start our product section  */}
      <div className="container py-lg-5 py-sm-3">
        <div className="row text-center">
          <h1 className='main-heading' data-aos="zoom-in" >Our Products</h1>
        </div>
        <div className="row ">
          <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card health-card" data-aos="zoom-in">
              <div className='home-product-card p-3'>
                <h4>Prescription Drugs</h4>
                <p>A wide range of prescription medications across various therapeutic areas, including cardiology, oncology, neurology, and more. Our drugs are developed with a focus on efficacy and patient safety.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card health-card" data-aos="zoom-in">
              <div className='home-product-card p-3'>
                <h4>Over-the-counter (OTC) Products</h4>
                <p>Easily accessible solutions for everyday health needs, from pain relief to allergy management. We provide high-quality, affordable OTC products that patients can trust.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card health-card" data-aos="zoom-in">
              <div className='home-product-card p-3'>
                <h4>Speciality Drugs</h4>
                <p>Innovative treatments for rare and complex conditions. We are dedicated to making advanced therapies available to those who need them most.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card health-card" data-aos="zoom-in">
              <div className='home-product-card p-3'>
                <h4>Pipeline Products</h4>
                <p>Oreus Lifesciences is constantly innovating. Our pipeline is full of exciting developments, with several products in various stages of clinical trials. Stay tuned for our next breakthrough.

                </p>
              </div>
            </div>
          </div>
        </div>

        

      </div>
      {/* end our product section  */}

      {/* Start Service section  */}
      <div className="container py-lg-5 py-sm-3">
        <div className="row text-center">
          <div className="h6-heading" data-aos="zoom-in" >Live happily, Live healthily</div>
          <h1 className='main-heading' data-aos="zoom-in">Services</h1>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                <h4>Pharmacovigilance</h4>
                <p>Ensuring patient safety through rigorous monitoring of drug effects and adverse reactions, maintaining a commitment to the highest standards of care. </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                {/* <i className="bi bi-heart-pulse"></i> */}
                <h4>Contract Manufacturing</h4>
                <p>We offer comprehensive contract manufacturing services, supporting the production needs of various pharmaceutical companies and ensuring quality and regulatory compliance.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                {/* <i className="bi bi-capsule-pill"></i> */}
                <h4>Research & Development (R&D)</h4>
                <p> At Oreus Lifesciences, R&D is at the heart of everything we do. Our team of experts is dedicated to discovering new treatments, with a focus on solving unmet medical needs.</p>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                <i className="bi bi-heart-pulse"></i>
                <p style={{ fontWeight: 'bolder' }}>Calsica</p>
                <p>Calcium Citrate (1000mg):Essential for bone health, Calcium Citrate provides a bioavailable source of calcium,</p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                <i className="bi bi-activity"></i>
                <p style={{ fontWeight: 'bolder' }}>Elsanac-MR</p>
                <p>Triple Action Pain Relief:Aceclofenac provides anti-inflammatory relief, Chlorzoxazone offers muscle relaxation, and Paracetamol </p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                <i className="bi bi-person-arms-up"></i>
                <p style={{ fontWeight: 'bolder' }}>Elsanac-SP</p>
                <p>Triple-Threat Pain Relief:Aceclofenac, Serratiopeptidase, and Paraceta-mol form a powerful trio, </p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                <i className="bi bi-plus-square-fill"></i>
                <p style={{ fontWeight: 'bolder' }}>Mivalp-OD</p>
                <p>Mood Stability & Bipolar Support:Divalproex Sodium ER (250/500mg) excels in stabilizing mood, offering crucial support for </p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
              <i className="bi bi-heart-pulse"></i>
                <p style={{ fontWeight: 'bolder' }}>Oreoclav-625</p>
                <p>Versatile Infection Management:Tailored for respiratory, urinary, and skin infections, it provides comprehensive coverage </p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
              <i className="bi bi-archive"></i>
                <p style={{ fontWeight: 'bolder' }}>Oreocetam-Inj</p>
                <p>Cognitive Supportor:Piracetam enhances mental clarity and focus. </p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
              <i className="bi bi-person-arms-up"></i>
                <p style={{ fontWeight: 'bolder' }}>Oreocetam-Syp</p>
                <p>Cognitive Supportor:Piracetam enhances mental clarity and focus.</p>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card live-card" data-aos="zoom-in">
              <div className="live-card-content">
                <i className="bi bi-archive"></i>
                <p style={{ fontWeight: 'bolder' }}>Memocephal-SYP</p>
                <p>Ashwagandha	Withania somnsfera	1500mg<br/>
                Shankhpushpi	Convolvulus pluricaulis	1000mg</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* end Service section  */}

      {/* Start Healthcare Professionals Section  */}
      <div className="container py-lg-5 py-sm-3">
        <div className="row">
          <h1 className='main-heading mt-lg-3' data-aos="zoom-in">Healthcare Professionals</h1>
        </div>
        <div className="row d-flex align-items-center">
          <div className="col-lg-6 col-md-6">
            <div className="healthcare-img-container" >
              <img className='img-fluid' data-aos="zoom-in" src={healthcare} alt="" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="healthcare-content" data-aos="zoom-in">
              <h4>Resources & Guidelines</h4>
              <p>Extensive product information, dosage guidelines, and clinical support to help healthcare professionals make informed decisions for their patients.</p>
              <h4 className='mt-lg-5'>Clinical Trials</h4>
              <p>Stay updated on ongoing and upcoming clinical trials. Oreus Lifesciences is committed to advancing science through robust and ethical research practices.</p>
            </div>
          </div>
        </div>
      </div>
      {/* End Healthcare Professionals Section  */}

      {/* Start Patient Resources Section  */}
      <div className="container py-lg-5 py-sm-3">
        <div className="row">
          <h1 className="main-heading" data-aos="zoom-in">Patient Resources</h1>
        </div>
        <div className="row change-column-direction">
          <div className="col-lg-6 col-md-6 d-flex flex-column justify-content-center" data-aos="zoom-in">
            <h4>Medication Guides</h4>
            <p>Easy-to-understand instructions for patients using our products, including details on dosage, side effects, and usage tips.</p>
            <h4 className='mt-lg-5'>Support Programs</h4>
            <p>Oreus Lifesciences offers patient assistance programs to help those in need access our medications, ensuring no one is left without care.</p>
          </div>
          <div className="col-lg-6 col-md-6">
            <img className='img-fluid' data-aos="zoom-in" src={PatientResources} alt="" />
          </div>
        </div>
      </div>
      {/* End Patient Resources Section  */}

      {/* Start Investor Relations Section  */}
      <div className="container py-lg-5 py-sm-3">
        <div className="row">
          <h1 className="main-heading" data-aos="zoom-in">Investor Relations</h1>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <img className='img-fluid' data-aos="zoom-in" src={Investor} alt="" />
          </div>
          <div className="col-lg-6 col-md-6 d-flex flex-column justify-content-center" data-aos="zoom-in">
            <h4>Financial Performance</h4>
            <p>Access our financial reports, investor presentations, and stock performance updates. Transparency is key to building trust with our stakeholders.</p>
            <h4 className='mt-lg-5'>News and Press Releases</h4>
            <p>Stay informed on the latest updates from Oreus Lifesciences, including product launches, clinical trial results, and corporate announcements.</p>
          </div>

        </div>
      </div>
      {/* End Investor Relations Section  */}


      {/* Start Sustainability & Responsibility Section  */}
      <div className="container">
        <div className="row">
          <h1 className="main-heading" data-aos="zoom-in">Sustainability & Responsibility</h1>
        </div>
        <div className="row change-column-direction">
          <div className="col-lg-6 col-md-6 d-flex flex-column justify-content-center" data-aos="zoom-in">
            <h4>Corporate Social Responsibility (CSR)</h4>
            <p> We believe in giving back to the community. Oreus Lifesciences is involved in various CSR initiatives, from healthcare outreach programs to environmental sustainability projects.</p>
            <h4 className='mt-lg-5'>Environmental Impact</h4>
            <p>Committed to reducing our environmental footprint, Oreus Lifesciences follows green manufacturing processes and strives to make our operations as eco-friendly as possible.</p>
          </div>
          <div className="col-lg-6 col-md-6">
            <img className='img-fluid' data-aos="zoom-in" src={Sustainability} alt="" />
          </div>

        </div>
      </div>
      {/* End Sustainability & Responsibility Section  */}

      {/* Start Careers Section  */}
      <div className="container py-lg-5 py-sm-3">
        <div className="row">
          <h1 className="main-heading" data-aos="zoom-in">Join Our Team</h1><hr/>
        </div>
        <div className="row">
          <div className="col-12 mt-lg-5">
            <p className='top-content' data-aos="zoom-in">At Oreus Lifesciences, we are always looking for passionate and skilled individuals to join our team. Explore career opportunities and see how you can contribute to making a difference in global healthcare.</p>
            <p className='text-center mt-lg-5 mt-3' data-aos="zoom-in"> <Link to="/career"><button className='main-btn'>Join Us</button></Link></p>
          </div>
        </div>
      </div>
      {/* End Careers Section  */}

      {/* Start Contact Us Section  */}
      <div className="container py-lg-5 py-3">
        <div className="row">
          <h1 className="main-heading" data-aos="zoom-in">Contact Us</h1><hr />
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="home-contact-us mt-lg-3 pe-lg-5">
              <h4 className='main-heading mb-3' data-aos="zoom-in">Corporate Headquarters</h4>
              <div className="address" data-aos="zoom-in">
              <i className="bi bi-geo-alt"></i>
              <p><span>Address : </span><br/>Oreus Life Sciences Private Limited 99-B, Mayur Vihar, Phase-1, New Delhi-110 091</p>
              </div>
              <div className="address" data-aos="zoom-in">
              <i className="bi bi-telephone"></i>
              <p><span>Phone : </span><br/> +91 97600 11544 <br/>+91 75000 82082 </p>
              </div>
              <div className="address" data-aos="zoom-in">
              <i className="bi bi-envelope"></i>
              <p ><span>Email : </span><br/> oreuslife@gmail.com</p>
              </div>
            </div>

          </div>
          <div className="col-lg-6 col-md-6">
            <h4 className="main-heading" data-aos="zoom-in">Customer Service</h4>
            <p data-aos="zoom-in"> For product enquiries or support, please contact us at +91 97600 11544, +91 75000 82082.</p>
          </div>
        </div>
      </div>
      {/* End Contact Us Section  */}


      {/* <div className="container pb-3">
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <div className="card about-card" data-aos="zoom-in">
              <div className="home-about-content">
                <i className="bi bi-archive"></i>
                <h6 className='h6-heading'>Drive Thru</h6>
                <p>Have a car full of kids or in a rush? Whatever your reason, we are here for you! Pick your package in less than 5 minutes as we keep it ready for you!</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-sm-6">
            <div className="card about-card" data-aos="zoom-in">
              <div className="home-about-content">
                <i className="bi bi-capsule"></i>
                <h6 className='h6-heading'>Drive Thru</h6>
                <p>Have a car full of kids or in a rush? Whatever your reason, we are here for you! Pick your package in less than 5 minutes as we keep it ready for you!</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-sm-6">
            <div className="card about-card" data-aos="zoom-in">
              <div className="home-about-content">
                <i className="bi bi-car-front"></i>
                <h6 className='h6-heading'>Drive Thru</h6>
                <p>Have a car full of kids or in a rush? Whatever your reason, we are here for you! Pick your package in less than 5 minutes as we keep it ready for you!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
        */}

      {/* <div className="container py-5">
        <div className="row">
          <h2 className='mb-4' data-aos="zoom-in">Ready to become our m​ember ?</h2>
          <h1 data-aos="zoom-in">We assure customer satisfaction with<br />personal care</h1>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <p data-aos="zoom-in">At Oreus customer satisfaction is always our top priority. If you have any queries feel free to reach us!</p>
            <img className='img-fluid' data-aos="zoom-in" src="https://plus.unsplash.com/premium_photo-1681966907271-1e350ec3bb95?q=80&w=1493&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="" />
          </div>
          <div className="col-lg-6" data-aos="zoom-in">
            <h2 className='text-center'>Contact Us</h2>
            <form>
              <div className="mb-3">
                <label for="name" className="form-label">Name:</label>
                <input type="text" className="form-control" id="exampleFormControlInput1" />
              </div>
              <div className="mb-3">
                <label for="email" className="form-label">Email:</label>
                <input type="email" className="form-control" id="exampleFormControlInput1" />
              </div>
              <div className="mb-3">
                <label for="phone" className="form-label">Phone Number:</label>
                <input type="Number" className="form-control" id="exampleFormControlInput1" />
              </div>
              <div className="input-group">
                <span className="input-group-text">Message</span>
                <textarea className="form-control" aria-label="With textarea"></textarea>
              </div>
              <div className='text-end'>
                <input type='submit' className='btn btn-success my-3' />
              </div>
            </form>

          </div>
        </div>
      </div> */}

      {/* <div className="container py-5">
        <div className="row" >
          <h1 className='our-trusted' data-aos="zoom-in">Our Trusted Partners</h1>
        </div>
        <div className="row" data-aos="zoom-in">
          <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={brand1} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={brand2} className="d-block w-100" alt="..." />
              </div>

            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div> */}

    </div>
  )
}

export default Home
